import { supportedLanguages } from './i18n';
import { Language } from './types';

export const isSupportedLanguage = (lang: string): lang is Language =>
  supportedLanguages.includes(lang as Language);

export const browserLanguage = (): Language => {
  const language = navigator.language || navigator.languages?.[0];
  const lang = language.split('-')[0] as Language;

  return isSupportedLanguage(lang) ? lang : 'en';
};
